<template>
    <section-layout class="section-howToWin">
        <div class="d-flex justify-content-center">
            <div class="section-howToWin__content col-sm-16 -pt-4 -pt-sm-14">
                <p class="heading-40 color-blue text-center mb-5">Weź udział<br>i zgarnij stypendium!</p>

                <div class="section-howToWin__item d-flex flex-column flex-sm-row align-items-center">
                    <div class="section-howToWin__image-container" :class="{'opacity-50': stageStatus >= 3}">
                        <img src="@/assets/HowToWin-pic1.svg" alt="" class="section-howToWin__image"/>
                        <img src="@/assets/HowToWin-nr1.svg" alt="" class="section-howToWin__image-number d-none d-sm-block"/>
                        <img src="@/assets/HowToWin-nr1-mobile.svg" alt="" class="section-howToWin__image-number d-sm-none"/>
                    </div>
                    <div class="d-flex align-items-center" :class="{'opacity-50': stageStatus >= 3}">
                        <div class="section-howToWin__content">
                            <p class="heading-24 color-blue">KROK 1. Zgłoś się! </p>
                            <p class="section-howToWin__text text-16">Wypełnij formularz kontaktowy – napisz o sobie i swoim talencie.<br><span class="heading-16 color-blue">Czekamy na Twoje zgłoszenie do 31 października 2026 r.</span> Najciekawsi kandydaci przejdą do kolejnego etapu. Trzymamy kciuki!</p>
                            <router-link v-if="stageStatus == 2" :to="{ name: 'signUpStudent' }" class="button__red">Formularz zgłoszeniowy<img
                                src="@/assets/right-btn.svg" alt="" class="button__arrow" /></router-link>
                        </div>
                    </div>
                </div>
        
                <div class="section-howToWin__item d-flex flex-column flex-sm-row align-items-center">
                    <div class="section-howToWin__image-container" :class="{'opacity-50': stageStatus >= 7}">
                        <img src="@/assets/HowToWin-pic2.svg" alt="" class="section-howToWin__image" />
                        <img src="@/assets/HowToWin-nr2.svg" alt="" class="section-howToWin__image-number d-none d-sm-block "/>
                        <img src="@/assets/HowToWin-nr2-mobile.svg" alt="" class="section-howToWin__image-number d-sm-none"/>
                    </div>
                    <div class="d-flex align-items-center" :class="{'opacity-50': stageStatus >= 7}">
                        <div class="section-howToWin__content">
                            <p class="heading-24 color-blue">KROK 2. Pokaż swój talent na video!</p>
                            <p class="section-howToWin__text text-16">Jesteś w drugim etapie? Brawo! Teraz nagraj <span class="heading-16 color-blue">krótki filmik o swojej pasji</span> i powiedz, dlaczego właśnie do Ciebie powinno trafić stypendium Enei?</p>
                        </div>
                    </div>
                </div>

                <div class="section-howToWin__item d-flex flex-column flex-sm-row align-items-center">
                    <div class="section-howToWin__image-container" :class="{'opacity-50': stageStatus >= 8}">
                        <img src="@/assets/HowToWin-pic3.svg" alt="" class="section-howToWin__image"/>
                        <img src="@/assets/HowToWin-nr3.svg" alt="" class="section-howToWin__image-number d-none d-sm-block"/>
                        <img src="@/assets/HowToWin-nr3-mobile.svg" alt="" class="section-howToWin__image-number d-sm-none"/>
                    </div>
                    <div class="d-flex align-items-center" :class="{'opacity-50': stageStatus >= 8}">
                        <div class="section-howToWin__content">
                            <p class="heading-24 color-blue">KROK 3. Czas zagłosować!</p>
                            <p class="section-howToWin__text text-16">Teraz pora na głosowanie internautów oraz jury, którzy wspólnie wybiorą najciekawsze filmy na stronie konkursowej.<br>Może wśród nich będzie Twój?</p>
                        </div>
                    </div>
                </div>

                <div class="section-howToWin__item d-flex flex-column flex-sm-row align-items-center" :class="{'opacity-50': stageStatus >= 10}">
                    <!-- <img src="@/assets/HowToWin-pic4.svg" alt="" class="section-howToWin__image"/> -->
                    <div class="section-howToWin__image-container">
                        <img src="@/assets/HowToWin-pic4.svg" alt="" class="section-howToWin__image"/>
                        <img src="@/assets/HowToWin-nr4.svg" alt="" class="section-howToWin__image-number d-none d-sm-block"/>
                        <img src="@/assets/HowToWin-nr4-mobile.svg" alt="" class="section-howToWin__image-number d-sm-none"/>
                    </div>
                    <div class="d-flex align-items-center" :class="{'opacity-50': stageStatus >= 10}">
                        <div class="section-howToWin__content">
                            <p class="heading-24 color-blue">KROK 4. Zgarnij stypendium o wysokości 5000 zł!</p>
                            <p class="section-howToWin__text text-16">W tej edycji na laureatów czeka aż <span class="heading-16 color-blue">80 stypendiów po 5000 zł</span> w kategoriach: nauki ścisłe, nauki przyrodnicze i zaangażowanie społeczne.<br>Zostań jednym z 80 wspaniałych! Powodzenia!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section-layout>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
            showContent: true,
        };
    },
    methods: {
    },
    components: {
    },
    computed: {
        applicationActive() {
            return this.$store.state.applicationActive
        },
        votesActive() {
            return this.$store.state.votesActive
        },
        finalistActive() {
            return this.$store.state.finalistActive
        },
        stageStatus() {
            return this.$store.state.stage
        }
    },
    
};
</script>
